module.exports = __webpack_public_path__ + "video-icon.svg?a2bba63f9e38eca8907e7614d7c8c9be";